<mat-tab-group class="api-configuration-tabs" (selectedTabChange)="onTabChange($event)">
    <mat-tab [label]="wizardMenuLabels.get(ApiConfigurationWizardStep.General)">
        <div class="api-configuration-tab">
            <div class="api-configuration-tab-content">
                <app-api-configuration-general></app-api-configuration-general>
            </div>
        </div>
    </mat-tab>
    <mat-tab [label]="wizardMenuLabels.get(ApiConfigurationWizardStep.Request)" [disabled]="!context.editedRestApiConfigurationId">
        <div class="api-configuration-tab">
            <div class="api-configuration-tab-content">
                <app-api-configuration-request [context]="context"></app-api-configuration-request>
            </div>
        </div>
    </mat-tab>
    <mat-tab [label]="wizardMenuLabels.get(ApiConfigurationWizardStep.Response)" [disabled]="!context.editedRestApiConfigurationId">
        <div class="api-configuration-tab">
            <div class="api-configuration-tab-content">
                <app-api-configuration-response [context]="context"></app-api-configuration-response>
            </div>
        </div>
    </mat-tab>
    <mat-tab [label]="wizardMenuLabels.get(ApiConfigurationWizardStep.EventsList)" [disabled]="!context.editedRestApiConfigurationId">
        <div class="api-configuration-tab">
            <div class="api-configuration-tab-content">
                @if (currentApiConfigurationWizardStep === ApiConfigurationWizardStep.EventsList) {
                    <app-api-configuration-event-list
                        (itemSelected)="onEventSelected($event)"
                        (itemEdited)="onEventEdited($event)"
                        (itemDuplicated)="onEventDuplicated($event)"
                        (itemDisplayed)="onEventDisplayed($event)"
                        (itemsSorted)="onEventsSorted($event)"
                        (itemDeleted)="onEventDeleted($event)"
                        (itemCreated)="onEventCreated()"></app-api-configuration-event-list>
                }
                @if (currentApiConfigurationWizardStep === ApiConfigurationWizardStep.Event) {
                    <app-api-configuration-event
                        [editedEventConfiguration]="currentEventConfiguration"
                        (canceled)="onEventCanceled()"
                        (saved)="onEventSaved()"></app-api-configuration-event>
                }
            </div>
        </div>
    </mat-tab>
</mat-tab-group>

<ngx-spinner name="apiConfiguration-wizard-spinner" bdColor="var(--avm-color-30)" color="var(--spinner-color)" [fullScreen]="false" type="timer" size="medium"></ngx-spinner>
